import React from 'react';
const IconNavBellFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9998 22.5C13.2098 22.5 14.2198 21.64 14.4498 20.5H9.5498C9.7798 21.64 10.7898 22.5 11.9998 22.5Z" fill="#2D2E2E"/>
<path d="M19.73 14.94L19.27 8.75C18.99 4.96 15.79 2 12 2C8.21 2 5.01 4.96 4.73 8.75L4.27 14.94L2.5 17.04V19H21.5V17.04L19.73 14.94Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavBellFill;